// ClassicShell — the original chat-thread layout, extracted verbatim from
// App.tsx. This is the regression baseline: every other shell is judged
// against parity with what this renders.
import { EmptyState } from '../components/EmptyState';
import { ChatInput } from '../components/ChatInput';
import { AssistantMessage } from '../components/AssistantMessage';
import { UserMessage } from '../components/UserMessage';
import { BlankInfoPanel } from '../components/BlankInfoPanel';
import { InfoPanel } from '../components/InfoPanel';
import type { ShellProps } from './types';

export function ClassicShell({ current, submit }: ShellProps) {
  return (
    <>
      <div className="main-with-sidebar">
        <main className="main">
          {!current ? (
            <EmptyState onSelectSuggestion={submit} />
          ) : (
            <div className="chat-view">
              <UserMessage text={current.query} />
              <AssistantMessage
                turn={current.assistant}
                streaming={current.streaming}
                toolsInFlight={current.toolsInFlight}
                stageLabel={current.stageLabel}
              />
            </div>
          )}
        </main>
        {!current ? (
          <BlankInfoPanel />
        ) : (
          <InfoPanel
            toolsUsed={current.assistant.toolsUsed}
            toolsInFlight={current.toolsInFlight}
            citations={current.assistant.citations}
            presentation={current.streaming ? null : current.assistant.presentation}
          />
        )}
      </div>

      <footer className="footer">
        <ChatInput
          onSubmit={submit}
          disabled={current?.streaming ?? false}
        />
      </footer>
    </>
  );
}
